import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const HeroSection = () => {
  const [now, setNow] = useState(new Date());
  const [visitCount, setVisitCount] = useState(null);

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    axios.post(`${BACKEND_URL}/api/visit`)
      .then(res => setVisitCount(res.data?.count ?? res.data?.total_visits ?? null))
      .catch(() => {});
  }, []);

  const dateStr = now.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const timeStr = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

  return (
    <section
      data-testid="hero-section"
      className="bg-black text-center"
      style={{ paddingTop: '16px', paddingBottom: '24px' }}
    >
      <div className="max-w-sm mx-auto px-6">
        {/* Logo */}
        <div
          className="mx-auto mb-2 w-48 sm:w-56"
          style={{
            maskImage: 'radial-gradient(ellipse 82% 68% at 50% 46%, black 32%, transparent 78%)',
            WebkitMaskImage: 'radial-gradient(ellipse 82% 68% at 50% 46%, black 32%, transparent 78%)',
          }}
        >
          <img
            src="/assets/pdx-logo-main.jpeg"
            alt="PDX Window Tint"
            className="w-full h-auto"
            style={{ display: 'block' }}
          />
        </div>

        {/* Date · time · visitor count */}
        <div
          className="flex items-center justify-center gap-2 mb-5"
          style={{ color: '#a1a1aa', fontSize: '13px', fontWeight: 600, letterSpacing: '0.02em' }}
        >
          <span data-testid="live-clock">{dateStr} · {timeStr}</span>
          {visitCount !== null && (
            <>
              <span style={{ color: '#3f3f46' }}>·</span>
              <span data-testid="visit-counter" style={{ color: '#eab308', fontFamily: 'monospace' }}>
                {visitCount.toLocaleString()} visits
              </span>
            </>
          )}
        </div>

        {/* Heading */}
        <h1
          className="font-black uppercase leading-none mb-2 whitespace-nowrap"
          style={{
            color: '#eab308',
            fontSize: 'min(7.8vw, 2.4rem)',
            letterSpacing: '0.06em',
          }}
        >
          LET'S GET STARTED
        </h1>

        {/* Subheading */}
        <p style={{ color: '#71717a', fontSize: '0.9rem' }}>Choose a service</p>
      </div>
    </section>
  );
};
